export default function hideKeyboard() {
    let inputId = 'LotHideKeyboardDInput'
    var field = document.createElement('input');
    field.style.position="fixed"
    field.style.top="-100px"
    field.style.width="0px";
    field.setAttribute('type', 'text');
    field.setAttribute('inputmode', 'none');
    field.setAttribute('id', 'LotHideKeyboardDInput');
    document.body.appendChild(field);

    const timeOutId = setTimeout(function () {
        field.focus();
        setTimeout(function () {
            field.setAttribute('style', 'display:none;');
            const element = document.getElementById(inputId);
            if (element) {
                element!.parentNode!.removeChild(element);
            }
            clearTimeout(timeOutId);
        }, 50);
    })
}